import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6s3mzfcgn: FaireProductEntity = {
  token: "p_d6s3mzfcgn",
  type: "product",
  name: "Diet Coke Bottle Hair Claw Clip, Fun Acetate Hair Accessory",
  brandToken: "b_2fgt3byexw",
  brandName: "TheDivaSoap",
  imageUrl:
    "https://cdn.faire.com/fastly/0b5cf2419a9744671f346af6d467b5f17b4604afea6d4b7094cbad0cb75e47eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0d9d05684bdabb45f22d11058e30c5776cb2e770795398f7ab8606d30d07e3ae.jpeg",
    "https://cdn.faire.com/fastly/b09500f0cc25d9463bca4302af90d0c71e47d2911fe1f54956a841dd4390b318.jpeg",
    "https://cdn.faire.com/fastly/5d8874c6c9d6465108660458acfc9741bf3045439ac63c54ea569f47052690d6.jpeg",
    "https://cdn.faire.com/fastly/3810baaa55104ace829fe365e8ee34b217e1d738f04fa61541cb8ef08855398f.jpeg",
  ],
  priceDollars: 4.56,
  description:
    "Size:10*4.7*3.4cm\nWeight: 36g\nMain Material: Acetate\n\n\nAdd a refreshing twist to your hairstyle with this Coke bottle acetate hair clip. Designed with a fun soda-inspired shape, it’s the perfect blend of playful style and trendy fashion. Made from high-quality acetate, this clip is lightweight, durable, and comfortable for all-day wear. Whether you’re heading to a party, casual outing, or just want to show off your love for unique accessories, this cola design hairpin makes a stylish statement. A great addition to your fashion hair accessories collection and a perfect gift for soda lovers and trendsetters.",
  tags: [],
  msrpDollars: 9.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:42.729Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
